
function getDefaultLocale(): string {
  let defaultLocale = 'en';
  if (typeof process !== 'undefined' && process.env.DEFAULT_LOCALE) {
    defaultLocale = process.env.DEFAULT_LOCALE;
  }
  return defaultLocale;
}

export const defaultLocale = getDefaultLocale();
